
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/g",
      function () {
        return require("private-next-pages/g/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/g"])
      });
    }
  